import { useState } from 'react';
import { useVantifyContext } from 'integrations-vantify-context-providers';
import {
  getJobGroups,
  JobGroup,
} from 'integrations-vantify-client-services';
import { useVantifyBase } from '../useVantifyBase';
import { VantifyOperation, hookMessages } from '../common';

export function useVantifyCategories() {
  const { auth } = useVantifyContext();
  const { loading, error, execute, setError } = useVantifyBase();
  const [categories, setCategories] = useState<JobGroup[] | null>(null);

  const fetchCategories = async () => {
    if (!auth) {
      setError((e) => ({
        ...e,
        [VantifyOperation.FETCH_CATEGORIES]: hookMessages.error_FETCH_CATEGORIES,
      }));

      return null;
    }

    const response = await execute(
      VantifyOperation.FETCH_CATEGORIES,
      () => getJobGroups(auth),
      hookMessages.error_FETCH_CATEGORIES
    );

    if (response?.data?.jobgroups) {
      setCategories(response.data.jobgroups);

      return response.data.jobgroups;
    }

    return null;
  };

  return {
    categories,
    loading,
    error,
    fetchCategories,
  };
}

